import { MainLayout } from '../../../components/Modules/Layout';
import { Breadcrumb, Col, Form, Row, Select, message } from 'antd';
import { useFormik } from 'formik';
import { useQuery } from 'react-query';
import { Content } from 'antd/es/layout/layout';
import ApprovalApi from 'apis/ApprovalApi';
import { ICreateApprove } from 'interface/approve.interface';
import { approvalOption, approvalDateOption } from 'mock/approve-mockup';
import pageTitleStore from 'store/pageTitleStore';
import { useEffect } from 'react';
import Button from 'components/Button';

export default function CreateApproval() {
  const {
    data: result,
    isLoading,
    refetch,
  } = useQuery(['getAllDivision'], () => ApprovalApi.getAllDivision());

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  useEffect(() => {
    setTitle('Tạo mới');
    setBreadcrumb([
      { title: <a href="/department-approval">Phê duyệt</a> },
      { title: <a href="/department-approval/addNew">Tạo mới</a> },
    ]);
  }, []);

  const { data: result1 } = useQuery(['getAllCategor'], () =>
    ApprovalApi.getAllCategory()
  );

  const renderCategoryOption = (categoryOption: Array<any>) => {
    return categoryOption.map((item) => {
      return (
        <Select.Option key={item.id} value={item.pof_type_code}>
          {item.pof_type_name}
        </Select.Option>
      );
    });
  };

  const renderDivisionOptions = (divisionList: Array<any>) => {
    return divisionList.map((item) => {
      return (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      );
    });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      division_id: 0,
      pof_type_code: '',
      list_setting: [
        {
          approve_stage: 1,
          approve_level: 0,
          date_end: 0,
        },
        {
          approve_stage: 2,
          approve_level: 0,
          date_end: 0,
        },
        {
          approve_stage: 3,
          approve_level: 0,
          date_end: 0,
        },
        {
          approve_stage: 4,
          approve_level: 0,
          date_end: 0,
        },
      ],
      updated_by: '',
      created_by: '',
    },
    onSubmit: (values: ICreateApprove) => {
      const Values = formik.values;
      ApprovalApi.postApproval(Values)
        .then((res) => {
          message.success('tạo mới thành công');
          setTimeout(() => {
            window.location.href = `/department-approval`;
          }, 1000);
        })
        .catch((err) => {
          message.error('tạo mới thất bại');
          console.log(err);
        });
    },
  });

  const handleChangeSelect = (name: string) => {
    return (value: any) => {
      formik.setFieldValue(name, value);
    };
  };

  const renderLeverOption = (listOption: Array<any>) => {
    return listOption?.map((item) => {
      return (
        <Select.Option key={item.value} value={item.value}>
          {item.label}
        </Select.Option>
      );
    });
  };

  return (
    <MainLayout isLoading={isLoading}>
      <div className="mb-4 flex flex-col gap-4 pb-20 border-b-2 border-[#E1E3E6]">
        <Content>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={12}>
              <Form layout="vertical">
                <Form.Item label="Khối phát hành">
                  <Select
                    placeholder="Click here to select"
                    onChange={handleChangeSelect('division_id')}
                  >
                    {renderDivisionOptions((result?.data || []) as any)}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
            <Col className="" span={12}>
              <Form layout="vertical">
                <Form.Item label="Loại danh mục">
                  <Select
                    placeholder="Click here to select"
                    onChange={handleChangeSelect('pof_type_code')}
                  >
                    {renderCategoryOption((result1?.data || []) as any)}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Content>

        {/* Phát hành danh mục */}
        <Content>
          <div className="mb-4">
            <p className="text-base font-bold">1. Phát hành danh mục</p>
          </div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={12}>
              <Form layout="vertical">
                <Form.Item label="Cấp phê duyệt">
                  <Select
                    placeholder="Click here to select"
                    onChange={handleChangeSelect(
                      'list_setting[0].approve_level'
                    )}
                  >
                    {renderLeverOption(approvalOption)}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
            <Col className="" span={12}>
              <Form layout="vertical">
                <Form.Item label="Thời gian phê duyệt">
                  <Select
                    placeholder="Click here to select"
                    onChange={handleChangeSelect('list_setting[0].date_end')}
                  >
                    {renderLeverOption(approvalDateOption)}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Content>

        {/* Chi nhánh đăng kí mẫu */}
        {/* <Content>
          <div className="mb-4">
            <p className="text-base font-bold">2. Phân bố chi nhánh</p>
          </div>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={12}>
              <Form layout="vertical">
                <Form.Item label="Cấp phê duyệt">
                  <Select
                    placeholder="Click here to select"
                    onChange={handleChangeSelect(
                      'list_setting[1].approve_level'
                    )}
                  >
                    {renderLeverOption(approvalOption)}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
            <Col className="" span={12}>
              <Form layout="vertical">
                <Form.Item label="Thời gian phê duyệt">
                  <Select
                    placeholder="Click here to select"
                    onChange={handleChangeSelect('list_setting[1].date_end')}
                  >
                    {renderLeverOption(approvalDateOption)}
                  </Select>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Content> */}

        {/* Đăng ký giỏ hàng danh mục */}
        <Content>
          <div className="mb-4">
            <p className="text-base font-bold">2. Phân bố cửa hàng</p>
          </div>

          <div className="border-b-2 border-dashed">
            <div className="mb-4">
              <p className="text-base font-bold">
                A. Chi nhánh (chỉ phê duyệt đơn thuộc chi nhánh)
              </p>
            </div>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={12}>
                <Form layout="vertical">
                  <Form.Item label="Cấp phê duyệt">
                    <Select
                      placeholder="Click here to select"
                      onChange={handleChangeSelect(
                        'list_setting[2].approve_level'
                      )}
                    >
                      {renderLeverOption(approvalOption)}
                    </Select>
                  </Form.Item>
                </Form>
              </Col>
              <Col className="" span={12}>
                <Form layout="vertical">
                  <Form.Item label="Thời gian phê duyệt">
                    <Select
                      placeholder="Click here to select"
                      onChange={handleChangeSelect('list_setting[2].date_end')}
                    >
                      {renderLeverOption(approvalDateOption)}
                    </Select>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </div>
          <div className="mt-4">
            <div className="mb-4">
              <p className="text-base font-bold">B. Hội sở</p>
            </div>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={12}>
                <Form layout="vertical">
                  <Form.Item label="Cấp phê duyệt">
                    <Select
                      placeholder="Click here to select"
                      onChange={handleChangeSelect(
                        'list_setting[3].approve_level'
                      )}
                    >
                      {renderLeverOption(approvalOption)}
                    </Select>
                  </Form.Item>
                </Form>
              </Col>
              <Col className="" span={12}>
                <Form layout="vertical">
                  <Form.Item name="plantCode" label="Thời gian phê duyệt">
                    <Select
                      placeholder="Click here to select"
                      onChange={handleChangeSelect('list_setting[3].date_end')}
                    >
                      {renderLeverOption(approvalDateOption)}
                    </Select>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </div>
        </Content>
      </div>
      <div>
        <Form onSubmitCapture={formik.handleSubmit}>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="end"
            className="mb-1"
          >
            <Col span={12} className="flex justify-end">
              <Button type="submit">Tạo mới</Button>
            </Col>
          </Row>
        </Form>
      </div>
    </MainLayout>
  );
}
